import React from 'react'
import { Avatar, Typography, Space, Row, Col, Divider, } from 'antd';
import { TeamOutlined, MessageOutlined, UserOutlined, PhoneOutlined, ToolOutlined, CustomerServiceOutlined,  } from '@ant-design/icons';
import './UserCard.css';
import { Restricted } from '../../../UI/Restricted.component';

const { Title, Text, Link } = Typography;

export const UserCard = ({account, ...props}) => {    

    const { username, firstName, lastName, accountType, email, companyName, phone, } = account;

    const cardAvatar = `${firstName ? firstName.charAt(0) : ''}${lastName ? lastName.charAt(0) : ''}`;
    const cardCompanyName = companyName ? <Space><TeamOutlined/>{companyName}</Space> : null;
    const cardPhoneNumber = phone ? <Space className='hover--copyable'><PhoneOutlined/><Text copyable>{phone}</Text></Space> : null;
    const cardEmail = email ? <Space align='start' className='hover--copyable'><MessageOutlined/><Text copyable>{email}</Text></Space> : null;
    const cardAccountType = accountType ? <Text align='center'>{`(${accountType})`}</Text> : null;

    const userInfo = (
        <div className="account__user-card--info">
            <Col justify='middle' style={{marginBottom: 20}}>
                <Title level={5} style={{margin: 0}}>
                    {firstName} {lastName}
                </Title>
                <Space direction='vertical' size='small'>
                    <Text type='secondary'>{username}</Text>
                    {cardAccountType}
                </Space>
            </Col>
            {cardCompanyName}
            {cardPhoneNumber}
            {cardEmail}

            <Restricted to='server.cloud1x'>
                <Divider orientation="left" orientationMargin="0">External Links</Divider>
                <Link href="https://fuelsupport.avalannetworks.com/portal/en/kb/articles/remote-monitoring" target="_blank"><Space><ToolOutlined />Troubleshooting</Space></Link>
                <Link href="https://fuelsupport.avalannetworks.com/portal/en/newticket?departmentId=468263000001172049&layoutId=468263000001174354" target="_blank"><Space><CustomerServiceOutlined />Support Ticket</Space></Link>
            </Restricted>
        </div>
    );

    return(
        <>  
            <div className="account__user-card">
                <Row justify='center' align='middle'>
                    <Avatar size={150}>{firstName || lastName ? cardAvatar : <UserOutlined/>}</Avatar>
                </Row>
                {userInfo}
            </div> 
        </>
    );
};

UserCard.defaultProps = {
    firstName: '', 
    lastName: '', 
    email: '', 
    companyName: '', 
    phone: '', 
    locations: [], 
    accesses: [],
}

